import produce from 'immer'
import { SET_SUPPLIERS } from './actionTypes'

export const initialState = {
  suppliers: {
    data: [],
    count: null,
  },
}

/* eslint-disable default-case */
const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_SUPPLIERS:
        draft.suppliers = action.data
        break
    }
  })

export default appReducer
